export default __webpack_public_path__ + "static/media/child1.04d6adf1.png";